@use "variables" as *;

.collectionCard {
  margin: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.contentCard {
  position: relative;
  margin: $spacing-m;
  overflow: auto !important;
  height: 76vh;
}

.cardContainer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.searchBar {
  justify-content: center;
}
